import { all } from "@redux-saga/core/effects";

import { generalSagas } from "../services/general/sagas";

import { stepOneSagas } from "./One/services/sagas";
import { stepSecondSagas } from "./Two/services/sagas";

export function* configManagerLiteSaga() {
    yield all([
        generalSagas(),
        stepOneSagas(),
        stepSecondSagas()
    ]);
}
